import { useEffect } from 'react';
import ProfilesDataTable from './ProfilesDataTable/ProfilesDataTable';

function Profiles() {
  
  // #region templates

  const viewTemplate = (
    <>
      <article>
        <section>
          <h1>
            Perfiles
          </h1>
        </section>
        <section>
          <ProfilesDataTable />
        </section>
      </article>
    </>
  );

  // #endregion

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  return (
    <>
      {viewTemplate}
    </>
  );
}

export default Profiles;